import { RoadDetailInfo as L2RRoadDetailInfo } from "@l2r-front/l2r-networks"
import { Partnership as UiPartnership, styled, styledForMobile } from "@l2r-front/l2r-ui"

export const Container = styledForMobile("div")(({ isMobile, theme }) => ({
    height: "100%",
    padding: isMobile ? theme.spacing(0, 4, 4, 4) : theme.spacing(0, 8, 8, 8),
}))

export const Logo = styled("img")(() => ({
    height: 40,
}))

export const ContentWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
}))

export const Partnership = styled(UiPartnership)(({ theme }) => ({
    alignItems: "flex-start",
    marginTop: theme.spacing(2),
}))

export const RoadDetailInfo = styled(L2RRoadDetailInfo)(({ isMobile, theme }) => ({
    marginTop: !isMobile && theme.spacing(5),
}))